import * as React from 'react';

export interface RouteIdContextProps {
	orgId?: string;
	siteId?: string;
	isLoading?: boolean;
	orgName?: string;
	siteName?: string | null;
	tenantId?: string;
}

const defaultRouteId: RouteIdContextProps = {
	orgId: undefined,
	siteId: undefined,
	isLoading: false,
	orgName: undefined,
	siteName: undefined,
	tenantId: undefined,
};

export const RouteIdContext: React.Context<RouteIdContextProps> =
	React.createContext(defaultRouteId);
